import _defineProperty from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/client-gatsby-loomi/client-gatsby-loomi/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { openEditor } from 'pintura';
import { sub, unsub } from './events';
var PinturaEditorModal = /*#__PURE__*/function (_React$Component) {
  _inherits(PinturaEditorModal, _React$Component);
  var _super = _createSuper(PinturaEditorModal);
  function PinturaEditorModal(props) {
    var _this;
    _classCallCheck(this, PinturaEditorModal);
    _this = _super.call(this, props);
    _this.editor = undefined;

    // We'll wrap the module in a container so we can use the container as a CSS module target
    _this.el = document.createElement('div');
    return _this;
  }
  _createClass(PinturaEditorModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // add the container
      document.body.appendChild(this.el);
      this.el.className = this.props.className;

      // create editor and proxy events
      var props = _objectSpread({}, this.props);
      this.editor = openEditor(props, this.el);
      sub(this, props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var props = _objectSpread({}, this.props);
      Object.assign(this.editor, props);
      sub(this, props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove our modal container
      document.body.removeChild(this.el);
      if (!this.editor) return;
      unsub(this);
      this.editor = undefined;
    }
  }, {
    key: "show",
    value: function show() {
      this.editor.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.editor.hide();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return PinturaEditorModal;
}(React.Component);
export default PinturaEditorModal;